import templateUrl from "emun.report/powerbi-prompt.htm";
import PowerBiPromptController from "emun.report/powerbi-prompt.controller";
import modals from "webmodals/modals";

const resolve = () => null;
const reject = reason => console.warn('reject reason', reason);

const PowerBiPrompt = {
  open(options) {
    const prom = modals.open(Object.assign({
      size: 'md quick-report-prompt',
      templateUrl,
      resolve: {
        options: () => options
      },
      bindToController: true,
      controller: PowerBiPromptController,
      controllerAs: '$ctrl'
    }, (options || {}).modal)).result;

    prom.then(resolve, reject);

    return prom;
  }
};

export default PowerBiPrompt;
